import { z } from 'zod';
import { ImageSchema } from '~entities/image/model/image.contracts';
import { RoomSchema } from '~entities/room/model/room.contracts';

export const LastMinutePackageSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  teaser: z.string(),
  description: z.string(),
  duration: z.number().int(),
  arrivalDay: z.string(),
  images: z.array(ImageSchema),
  room: RoomSchema.optional(),
});

export const PackageSchema = z.object({
  id: z.number().int(),
  sort: z.number().int(),
  name: z.string(),
  teaser: z.string(),
  description: z.string(),
  includedServices: z.string(),
  stayRanges: z.array(
    z.object({
      from: z.string(),
      to: z.string(),
    }),
  ),
  images: z.array(ImageSchema),
});
